import checkoutDataLoggedHtml from './checkoutdatalogged.component.html';
import checkoutAddNewAddressModalHtml from './checkoutaddnewaddress.modal.html';
import './checkoutdatalogged.component.scss';

class CheckoutDataLoggedController {
    constructor($scope, $rootScope, $window, CheckoutService, $sce, ModalService, translateService) {
        'ngInject';
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.service = CheckoutService;
        this.ModalService = ModalService;
        this.translate = translateService;
        this.$sce = $sce;
        this.countries = this.service.countries;
    }

    $onInit() {
        this.service.step = 2;
        this.service.userLogged = true;

        this.service.loadAddresses().then(
            (addresses) => {
                if(!this.service.data.shipmentAddressId) {
                    for (const address of addresses.shipment) {
                        if (address.default == 1) this.setShipmentAddress(address);
                    }
                }
                if(!this.service.data.invoiceAddressId) {
                    for (const address of addresses.invoice) {
                        if (address.default == 1) this.setInvoiceAddress(address);
                    }
                }

                if (!this.service.data.invoiceAddressId) {
                    for (const address of addresses.invoice) {
                        if (this.service.shopCountry === address.country) {
                            this.setInvoiceAddress(address);
                            break;
                        }
                    }
                }

                if (!this.service.data.invoiceAddressId && addresses.invoice && addresses.invoice.length > 0) {
                    this.setInvoiceAddress(addresses.invoice[0]);
                }
            }
        );

        this.$rootScope.$on('editInvoiceAddress', (event, data) => {
            this.editInvoiceAddress(data.address);
        });
    }

    setShipmentAddress(address) {
        this.service.data.shipmentAddressId = address.id;
    }

    setInvoiceAddress(address) {
        this.service.data.invoiceAddressId = address.id;
    }

    setDropshippingAddress(status, address) {
        this.service.data.isDropshippingAddress = status;
        this.service.data.dropshippingAddress = address;
    }

    editInvoiceAddress(address) {
        this.displayModal(0, this.translate.t('checkout.editInvoiceAddress'), this.service.shopCountry, modifiedAddress => {
            if (!modifiedAddress) return;

            modifiedAddress = this.service.transformAddress(modifiedAddress.data, true);
            for (const [prop, value] of Object.entries(address)) {
                address[prop] = modifiedAddress[prop];
            }
        }, address);
    }

    editShipmentAddress(address) {
        this.displayModal(1, this.translate.t('checkout.editShipmentAddress'), this.service.shopCountry, modifiedAddress => {
            if (!modifiedAddress) return;

            modifiedAddress = this.service.transformAddress(modifiedAddress.data, true);
            for (const [prop, value] of Object.entries(address)) {
                address[prop] = modifiedAddress[prop];
            }
        }, address);
    }

    displayModal(type, title, shopCountry, modalClosedCallback = () => {}, address = null) {
        this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = type;
                    this.title = title;
                    this.address = address;
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(modalClosedCallback);
        });
    }

    addNewShipmentAddress() {
        const shopCountry = this.service.shopCountry;
        let _this = this;
        let modal = this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 1;
                    this.title = _this.translate.t('checkout.newShipmentAddress');
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(address => {
                // Redirect to cart
                if (!address) return;

                const newAddress = {
                    id: address.id,
                    name: address.data.addressName,
                    first_name: address.data.firstName,
                    last_name: address.data.lastName,
                    company: address.data.companyName,
                    tax_id: address.data.taxNumber,
                    country: address.data.country,
                    zip: address.data.zipCode,
                    city: address.data.city,
                    address: address.data.address,
                    type: 1,
                    default: 0
                }

                this.service.addresses.shipment.push(newAddress);
                this.setShipmentAddress(newAddress);
            });
        });
    }

    addNewInvoiceAddress() {
        const shopCountry = this.service.shopCountry;
        let _this = this;
        let modal = this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.title = _this.translate.t('checkout.newInvoiceAddress');
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(address => {
                // Redirect to cart
                if (!address) return;

                const newAddress = {
                    id: address.id,
                    name: address.data.addressName,
                    first_name: address.data.firstName,
                    last_name: address.data.lastName,
                    company: address.data.companyName,
                    tax_id: address.data.taxNumber,
                    ico_id: address.data.icoNumber,
                    country: address.data.country,
                    zip: address.data.zipCode,
                    city: address.data.city,
                    address: address.data.address,
                    type: 0,
                    default: 0
                }

                this.service.addresses.invoice.push(newAddress);
                this.setInvoiceAddress(newAddress);
            });
        });
    }

    addDropshippingAddress() {
        const shopCountry = this.service.shopCountry;
        let address = {};

        if (this.service.data.isDropshippingAddress === true) {
            let dropshippingAddress = this.service.data.dropshippingAddress;
            address = {
                type: 2,
                companyName: dropshippingAddress.companyName,
                firstName: dropshippingAddress.firstName,
                lastName: dropshippingAddress.lastName,
                address: dropshippingAddress.address,
                city: dropshippingAddress.city,
                zipCode: dropshippingAddress.zipCode,
                country: dropshippingAddress.country
            };
        } else {
            let invoiceAddress = this.service.getAddressById(this.service.data.invoiceAddressId);
            address = {
                type: 2,
                companyName: invoiceAddress.company,
                firstName: invoiceAddress.first_name,
                lastName: invoiceAddress.last_name,
                address: invoiceAddress.address,
                city: invoiceAddress.city,
                zipCode: invoiceAddress.zip,
                country: invoiceAddress.country
            };
        }

        let modal = this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 2;
                    this.title = 'Adres nadawcy (dropshipping)';
                    this.address = address;
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(address => {
                if (!address) return;

                const newAddress = {
                    companyName: address.data.companyName,
                    firstName: address.data.firstName,
                    lastName: address.data.lastName,
                    address: address.data.address,
                    city: address.data.city,
                    zipCode: address.data.zipCode,
                    country: address.data.country
                }

                this.setDropshippingAddress(true, newAddress);
            });
        });
    }

    cancelDropshippingAddress() {
        const emptyAddress = {
            companyName: '',
            firstName: '',
            lastName: '',
            address: '',
            city: '',
            zipCode: '',
            country: ''
        };

        this.setDropshippingAddress(false, emptyAddress);
    }
}

let checkoutDataLoggedComponent = {
    bindings: {},
    template: checkoutDataLoggedHtml,
    controller: CheckoutDataLoggedController
}

export default checkoutDataLoggedComponent;
